module.exports = __webpack_public_path__ + "img/background_212.6e7e6053.png";